import React from 'react';
import clsx from 'clsx';
import styles from './ModalStyles.module.scss';
import { LottieContainer } from '../../../../components/animations/LottieContainer.tsx';
import animationData from '../../../../assets/animations/loader_big.json';
import animationDataFailure from '../../../../assets/animations/loader_big_error.json';
import {
  Button,
  ButtonColor,
} from '../../../../components/uikit/buttons/Button.tsx';
import { useScopedTranslation } from '../../../../application/localization/useScopedTranslation.ts';
import { useNavigate } from 'react-router';
import { NavLink } from 'react-router-dom';
import { Links } from '../../../../application/constants/links.ts';
import { SubmitLoadingType } from '../CreateRepairRequest.tsx';
import { formatDate } from '../../../../helpers/abas-helper.ts';

type OwnProps = {
  turnOffSubmitLoader: () => void;
  submitLoadingStatus: SubmitLoadingType;
  handleSubmit: () => void;
  goBackFromSubmitScreen: () => void;
};

const Email = 'TechnicalService@Löwensteinmedical.de';

export const SubmitLoading = (props: OwnProps) => {
  const {
    turnOffSubmitLoader,
    submitLoadingStatus,
    handleSubmit,
    goBackFromSubmitScreen,
  } = props;

  const i18n = useScopedTranslation('Page.CreateRepairRequest');

  const navigate = useNavigate();

  const navigateRepairs = () => {
    void navigate(Links.Authorized.Repairs.route);
  };

  const createAnotherRequest = () => {
    turnOffSubmitLoader();
  };

  const isSubmitError = submitLoadingStatus === 'error';
  const isLoading = submitLoadingStatus === 'loading';

  return (
    <div className={clsx(styles.errorContainer, styles.columnContainer)}>
      <LottieContainer
        animationData={isSubmitError ? animationDataFailure : animationData}
        segments={isLoading ? [1, 180] : [180, 300]}
        loop={isLoading}
      />
      {isLoading ? (
        <div className={clsx(styles.marginTop32)}>
          <div className={styles.errorTitle}>
            {i18n.t('request_submitting')}
          </div>
        </div>
      ) : (
        <div
          className={clsx(
            styles.columnContainer,
            styles.marginTop32,
            styles.alignItemsCenter,
          )}
        >
          <div className={clsx(styles.errorTitle, styles.marginBottom16)}>
            {i18n.t(isSubmitError ? 'failure' : 'request_success')}
          </div>
          {isSubmitError ? (
            <div
              className={clsx(styles.deviceGreyText, styles.textAlignCenter)}
            >
              {i18n.t('request_submission_failed')}
            </div>
          ) : (
            <>
              <div
                className={clsx(styles.deviceGreyText, styles.textAlignCenter)}
              >
                {i18n.t('contact_info', { date: formatDate(new Date()) })}
              </div>
              <div
                className={clsx(
                  styles.rowContainer,
                  styles.deviceGreyText,
                  styles.textAlignCenter,
                )}
              >
                <div>{i18n.t('please_contact')}</div>
                <NavLink
                  className={clsx(styles.link, styles.underline)}
                  to={`mailto:${Email}`}
                >
                  {Email}
                </NavLink>
              </div>
            </>
          )}
          {isSubmitError ? (
            <div
              className={clsx(
                styles.rowContainer,
                styles.columnGap16,
                styles.marginTop48,
              )}
            >
              <Button
                title={i18n.t('back')}
                color={ButtonColor.Secondary}
                onClick={goBackFromSubmitScreen}
              />
              <Button title={i18n.t('try_again')} onClick={handleSubmit} />
            </div>
          ) : (
            <div className={clsx(styles.rowContainer12, styles.marginTop48)}>
              <Button
                testId={'create-another-request-button'}
                title={i18n.t('create_another_request')}
                color={ButtonColor.Secondary}
                onClick={createAnotherRequest}
              />
              <Button
                title={i18n.t('go_to_repairs_page')}
                onClick={navigateRepairs}
              />
            </div>
          )}
        </div>
      )}
    </div>
  );
};
